/**
 * Created by duxiaojia on 2018/3/29.
 */
export default {
  state: {
    columnTitle: ''
  },
  mutations: {
    columnTitle (state, columnTitle) {
      state.columnTitle = columnTitle
    }
  },
  getters: {
    columnTitle: state => state.columnTitle
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ColumnStore.js